// src/index.tsx
import { Box, keyframes } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var sizes = {
  md: 48,
  lg: 64
};
var spin = keyframes`
  from {transform: rotate(180deg);}
  to {transform: rotate(540deg)}
`;
function ContentSpinner({ variant = "md", size }) {
  var _a;
  const sizePx = (_a = size != null ? size : sizes[variant]) != null ? _a : sizes["md"];
  const strokeWidth = sizePx / 8;
  const mask = "radial-gradient(circle, #0000 var(--inner), #000 var(--outer))";
  return /* @__PURE__ */ jsx(Box, {
    animation: `${spin} infinite .75s linear`,
    borderRadius: "50%",
    width: `${sizePx}px`,
    height: `${sizePx}px`,
    style: {
      "--rotation": "270deg",
      "--thickness": `${strokeWidth}px`,
      "--inner": "calc(70% - var(--thickness))",
      "--outer": "calc(var(--inner) + 1px)",
      maskImage: mask,
      WebkitMaskImage: mask,
      backgroundImage: "conic-gradient(transparent 0, var(--chakra-colors-primary-500) 40deg, var(--chakra-colors-primary-900) 91deg, var(--chakra-colors-secondary-500) 183deg, var(--chakra-colors-secondary-200) 253deg, transparent 275deg)"
    }
  });
}
export {
  ContentSpinner
};
